import { render, staticRenderFns } from "./depoimentosEditar.vue?vue&type=template&id=6397d8ee&scoped=true&"
import script from "./depoimentosEditar.vue?vue&type=script&lang=js&"
export * from "./depoimentosEditar.vue?vue&type=script&lang=js&"
import style0 from "./depoimentosEditar.vue?vue&type=style&index=0&id=6397d8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397d8ee",
  null
  
)

export default component.exports